import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { Helmet } from '@/pages/home/components/SEOHelmet';

const faqs = [
  {
    q: '妖精动漫网的漫画资源是否免费？',
    a: '是的，妖精动漫平台上的所有漫画资源均免费向用户开放阅读。我们致力于为广大漫画爱好者提供高质量、正版授权的免费漫画内容，让每一位用户都能尽情享受阅读乐趣。',
  },
  {
    q: '妖精动漫支持哪些类型的漫画？',
    a: '妖精动漫平台涵盖韩漫、日漫、国漫等多种类型，包括但不限于热血、恋爱、悬疑、奇幻、搞笑、动作、科幻、恐怖、耽美等丰富分类，满足不同读者的阅读偏好。',
  },
  {
    q: '如何在妖精动漫网站上找到想看的漫画？',
    a: '您可以通过首页的分类导航浏览不同类别的漫画，也可以使用页面顶部的搜索功能，输入漫画名称或作者名快速找到目标漫画。此外，排行榜和热门推荐也能帮您发现好看的漫画。',
  },
  {
    q: '妖精动漫支持手机阅读吗？',
    a: '妖精动漫网站采用响应式设计，完美适配手机、平板和电脑等多种设备。在手机上浏览时，您同样可以享受流畅的下拉式阅读体验，随时随地畅享漫画世界。',
  },
  {
    q: '妖精动漫的漫画更新频率如何？',
    a: '我们与多家版权方保持紧密合作，确保热门连载漫画能够及时同步更新。通常韩漫每周更新1-2话，日漫和国漫的更新频率则根据原作进度而定。您可以在"最新更新"板块实时追踪更新动态。',
  },
  {
    q: '阅读过程中遇到问题怎么办？',
    a: '如果您在阅读过程中遇到加载失败、页面异常等问题，可以尝试刷新页面或清除浏览器缓存。若问题持续存在，欢迎通过页面底部的联系方式或在线客服与我们取得联系，我们将尽快为您解决。',
  },
];

export default function AboutPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [formError, setFormError] = useState('');
  const [formSuccess, setFormSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');
    setFormSuccess(false);

    const form = e.currentTarget;
    const formData = new FormData(form);

    const websiteAlt = formData.get('website_alt') as string;
    if (websiteAlt && websiteAlt.trim() !== '') {
      setFormSuccess(true);
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9omu3aftmtnfcfh0a2g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries())
            .filter(([k]) => k !== 'website_alt')
            .map(([k, v]) => [k, v.toString()])
        ).toString(),
      });
      const responseText = await res.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setFormSuccess(true);
        form.reset();
      } else {
        const errMsg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
        if (errMsg.toLowerCase().includes('spam') || errMsg.includes('垃圾')) {
          setFormSuccess(true);
        } else {
          setFormError(errMsg);
        }
      }
    } catch {
      setFormError('网络错误，请检查网络后重试');
    }
  };

  return (
    <>
      <Helmet
        title="关于我们 - 妖精动漫 | 品牌介绍与联系方式"
        description="妖精动漫网致力于打造最优质的免费漫画阅读平台，提供韩漫、日漫、国漫全集高清在线阅读。了解妖精动漫的品牌故事、用户口碑和联系方式。"
        keywords="妖精动漫介绍,妖精动漫品牌,妖精动漫联系方式,免费漫画平台"
        canonical="https://www.yaojingdongman.com/about"
      />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="w-full px-4 md:px-6 py-8">
            <div className="max-w-5xl mx-auto">
              <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />

              {/* Hero */}
              <section className="mt-6 mb-16 text-center">
                <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                  关于妖精动漫
                </h1>
                <p className="text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                  妖精动漫网是一个专注于免费漫画阅读的在线平台，致力于为广大漫迷提供
                  <strong>韩漫</strong>、<strong>日漫</strong>、<strong>国漫</strong>等
                  全类型漫画的高清在线阅读体验。
                </p>
              </section>

              {/* Brand Story */}
              <section className="mb-16">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
                  品牌故事
                </h2>
                <div className="bg-background-100/70 rounded-2xl p-8 md:p-10">
                  <div className="max-w-3xl mx-auto space-y-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                    <p>
                      妖精动漫成立于2023年，由一群热爱漫画的资深漫迷共同创建。创始团队深知漫迷们在寻找高质量、便捷的阅读渠道时所面临的种种困扰——资源分散、画质模糊、加载缓慢、盗版横行。于是，「妖精动漫」应运而生。
                    </p>
                    <p>
                      我们的初心很简单：<strong>让每一位漫画爱好者都能轻松找到并免费阅读自己喜欢的漫画作品</strong>。妖精动漫平台从创立之初就坚持以用户体验为核心，持续优化阅读功能，引入正版授权资源，力求打造国内最优质的免费漫画阅读社区。
                    </p>
                    <p>
                      经过两年的发展，妖精动漫已积累了超过百万的注册用户，日均活跃读者突破十万。平台收录了上千部优质漫画作品，涵盖韩漫、日漫、国漫以及原创漫画，并与多家国内外知名漫画版权方建立了稳定的合作关系。
                    </p>
                    <p>
                      妖精动漫网独创的「下拉式阅读」模式，让读者可以像刷短视频一样流畅地翻阅漫画，极大地提升了移动端阅读的舒适度和沉浸感。同时，「追更收藏」功能帮助读者轻松管理阅读进度，不错过任何一话更新。
                    </p>
                  </div>
                </div>
              </section>

              {/* Features */}
              <section className="mb-16">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
                  平台特色
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {[
                    { icon: 'ri-shield-check-line', title: '正版授权', desc: '与多家版权方合作，为用户提供正版授权的漫画内容，支持创作者，尊重知识产权。' },
                    { icon: 'ri-smartphone-line', title: '多端适配', desc: '支持PC、平板、手机等多终端访问，响应式设计确保各设备都能获得最佳阅读体验。' },
                    { icon: 'ri-download-2-line', title: '下拉式阅读', desc: '独创的无限下拉阅读模式，无需翻页，沉浸式浏览，让漫画阅读如同刷短视频般流畅。' },
                    { icon: 'ri-time-line', title: '每日更新', desc: '热门漫画每日同步更新，实时追踪最新话，追更进度一目了然，不再错过精彩剧情。' },
                    { icon: 'ri-bookmark-line', title: '收藏追更', desc: '一键收藏喜欢的漫画，自动记录阅读进度，更新实时提醒，追更管理从未如此简单。' },
                    { icon: 'ri-group-line', title: '社区互动', desc: '活跃的读者社区，可以在每部漫画下评论交流，分享阅读感受，找到志同道合的漫友。' },
                  ].map((feat) => (
                    <div key={feat.title} className="p-6 rounded-xl bg-background-100/70 hover:bg-background-100 transition-colors">
                      <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
                        <i className={`${feat.icon} text-xl`}></i>
                      </div>
                      <h3 className="text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                      <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
                    </div>
                  ))}
                </div>
              </section>

              {/* Testimonials */}
              <section className="mb-16">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
                  用户口碑
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  {[
                    { name: '小丸子', text: '用了妖精动漫之后再也不去别的平台了！更新快、画质好，下拉式阅读太舒服了，通勤路上必备。', rating: 5 },
                    { name: '漫友阿强', text: '找了好久韩漫资源，终于在妖精动漫找到了全集。分类很全，搜索也好用，推荐给所有漫迷！', rating: 5 },
                    { name: '樱花下的约定', text: '国漫资源很多，而且都是高清版。收藏功能很好用，更新的漫画会自动提醒，再也不用一个个去翻了。', rating: 5 },
                    { name: '风一样的男子', text: '界面简洁清爽，没有乱七八糟的广告干扰阅读。下拉式阅读体验真的绝了，看一整天都不累。', rating: 5 },
                    { name: '漫画控Lily', text: '日漫资源很全，更新也快。最棒的是手机阅读体验，躺着看漫画太惬意了。妖精动漫yyds！', rating: 5 },
                    { name: '夜空中的星', text: '朋友推荐的这个平台，一用就离不开了。分类做得很好，排行榜也很有参考价值，帮我发现了不少好作品。', rating: 4 },
                  ].map((testimonial, idx) => (
                    <div key={idx} className="p-6 rounded-xl bg-background-100/70">
                      <div className="flex items-center gap-1 mb-3">
                        {Array.from({ length: 5 }, (_, i) => (
                          <i
                            key={i}
                            className={`ri-star-fill text-sm ${i < testimonial.rating ? 'text-accent-500' : 'text-foreground-200'}`}
                          ></i>
                        ))}
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                        &ldquo;{testimonial.text}&rdquo;
                      </p>
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-xs font-bold">
                          {testimonial.name[0]}
                        </div>
                        <span className="text-sm font-medium text-foreground-700">{testimonial.name}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              {/* FAQ */}
              <section className="mb-16">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
                  常见问题
                </h2>
                <div className="max-w-3xl mx-auto space-y-3">
                  {faqs.map((faq, idx) => (
                    <div key={idx} className="rounded-xl bg-background-100/70 overflow-hidden">
                      <button
                        onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                        className="w-full flex items-center justify-between px-5 py-4 text-left"
                      >
                        <span className="text-sm font-semibold text-foreground-800 pr-4">{faq.q}</span>
                        <i
                          className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform flex-shrink-0 ${
                            openFaq === idx ? 'rotate-180' : ''
                          }`}
                        ></i>
                      </button>
                      {openFaq === idx && (
                        <div className="px-5 pb-4">
                          <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </section>

              {/* Contact */}
              <section className="mb-16">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
                  联系我们
                </h2>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
                  {/* Contact Info */}
                  <div className="space-y-5">
                    <div className="p-5 rounded-xl bg-background-100/70 flex items-start gap-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                        <i className="ri-mail-line text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h4>
                        <p className="text-sm text-foreground-500">contact@yaojingdongman.com</p>
                      </div>
                    </div>
                    <div className="p-5 rounded-xl bg-background-100/70 flex items-start gap-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                        <i className="ri-customer-service-2-line text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-800 mb-1">在线客服</h4>
                        <p className="text-sm text-foreground-500">工作日 9:00 - 18:00</p>
                      </div>
                    </div>
                    <div className="p-5 rounded-xl bg-background-100/70 flex items-start gap-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                        <i className="ri-map-pin-line text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-800 mb-1">公司地址</h4>
                        <p className="text-sm text-foreground-500">中国·杭州</p>
                      </div>
                    </div>
                  </div>

                  {/* Contact Form */}
                  <div className="p-6 rounded-xl bg-background-100/70">
                    <h3 className="text-base font-semibold text-foreground-900 mb-5">发送消息</h3>
                    {formSuccess ? (
                      <div className="text-center py-8">
                        <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                          <i className="ri-check-line text-2xl"></i>
                        </div>
                        <p className="text-foreground-700 font-medium">消息已发送！</p>
                        <p className="text-sm text-foreground-500 mt-1">感谢您的留言，我们会尽快回复。</p>
                      </div>
                    ) : (
                      <form onSubmit={handleSubmit} className="space-y-4" data-readdy-form>
                        {/* Honeypot */}
                        <div className="website-alt-wrapper">
                          <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                        </div>

                        <div>
                          <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                            姓名
                          </label>
                          <input
                            type="text"
                            id="contact-name"
                            name="name"
                            required
                            className="w-full h-10 px-3 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                            placeholder="请输入您的姓名"
                          />
                        </div>
                        <div>
                          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                            邮箱
                          </label>
                          <input
                            type="email"
                            id="contact-email"
                            name="email"
                            required
                            className="w-full h-10 px-3 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                            placeholder="请输入您的邮箱"
                          />
                        </div>
                        <div>
                          <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                            留言内容
                          </label>
                          <textarea
                            id="contact-message"
                            name="message"
                            required
                            maxLength={500}
                            rows={4}
                            className="w-full px-3 py-2 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                            placeholder="请输入您的留言（最多500字）"
                          ></textarea>
                        </div>
                        {formError && (
                          <p className="text-sm text-red-500">{formError}</p>
                        )}
                        <button
                          type="submit"
                          className="w-full h-10 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold rounded-lg transition-colors whitespace-nowrap"
                        >
                          发送消息
                        </button>
                      </form>
                    )}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </main>
        <Footer />
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "AboutPage",
                "@id": "https://www.yaojingdongman.com/about#aboutpage",
                "name": "关于妖精动漫",
                "description": "妖精动漫网致力于打造最优质的免费漫画阅读平台，提供韩漫、日漫、国漫全集高清在线阅读。",
                "url": "https://www.yaojingdongman.com/about",
                "isPartOf": { "@id": "https://www.yaojingdongman.com/#website" },
                "about": { "@id": "https://www.yaojingdongman.com/#organization" },
                "inLanguage": "zh-CN"
              },
              {
                "@type": "FAQPage",
                "mainEntity": faqs.map((faq) => ({
                  "@type": "Question",
                  "name": faq.q,
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": faq.a,
                  },
                })),
              },
              {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "首页",
                    "item": "https://www.yaojingdongman.com",
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "关于我们",
                  },
                ],
              },
            ],
          }),
        }}
      />
    </>
  );
}